import API from 'api'
import { useEffect, useState } from 'react'
import sortBy from 'lodash/sortBy'
import filter from 'lodash/filter'
import { useDispatch, useSelector } from 'react-redux'
import {
  setGuestsSplitiing,
  setRoomParams,
  setSelectedTrip,
  setTotalPrice,
} from '../../../actions/checkout-la-actions'
import { parseQuery } from '../../../utils'
import { generateRoomParams } from './useGuestSplitting'
import useStep from './useStep'
import get from 'lodash/get'
import { showLoader } from '../../../actions/main-actions'

export default function useTrip(tripId) {
  const dispatch = useDispatch()
  const selectedTrip = useSelector((state) => state.selectedTrip)
  const { setStep } = useStep()
  const [cabins, setCabins] = useState([])

  const [requirements, setRequirements] = useState({})
  const getRequirements = () => {
    const id = get(selectedTrip, 'itinerary.id', '')
    if(!id) {
      return null
    }

    API(`shop/itinerary/${id}/requirements/`)
      .get()
      .then((res) => setRequirements(res))
  }

  const getTripData = () => {
    dispatch(showLoader(true))
    API(`shop/trips/${tripId}/`)
      .get()
      .then((selectedTrip) => {
        const params = parseQuery()
        let cabins = selectedTrip[0].packages
        const cabinPrices = []
        cabins.forEach((cabin) => {
          if(!cabin.availability) {
            cabin.availability = cabin.itemAvailability
          }
          cabin.pricesToShow = sortBy(
            filter(cabin.prices, {
              isShared: true,
            }),
            'isDiver'
          ).reverse()
          if(params.cabinPricing) {
            try {
              const selectedCabins = JSON.parse(params.cabinPricing)
              selectedCabins.forEach((selectedPrice) => {
                const prices = []
                let totalCabinPrice = 0
                const guests = {
                  divers: 0,
                  nonDivers: 0,
                  students: 0,
                }
                const cart = []
                selectedPrice.forEach((selectedPricing) => {
                  const cartObj = []
                  selectedPricing.forEach((pricing) => {
                    const cabinPrice = cabin.prices.find(
                      (cabin) => cabin.id === pricing.id
                    )
                    if(cabinPrice) {
                      totalCabinPrice += pricing.qty * cabinPrice.priceNet
                      if(cabinPrice.isDiver) {
                        guests.divers += pricing.qty
                      } else {
                        guests.nonDivers += pricing.qty
                      }
                      const data = {
                        ...cabinPrice,
                        qty: pricing.qty,
                      }
                      cartObj.push(data)
                      prices.push(data)
                    }
                  })
                  cart.push(cartObj)
                })
                if(prices?.length) {
                  cabinPrices.push({
                    title: cabin.roomCategory.title,
                    id: cabin.roomCategory.id,
                    ...guests,
                    totalGuests: guests.divers + guests.nonDivers,
                    cart,
                    totalCabinPrice,
                    pricing: prices,
                  })
                }
              })
            } catch (e) {
              console.error(e)
            }
          }
        })
        if(cabinPrices?.length) {
          const { roomParams, totalPrice } = generateRoomParams(cabinPrices)
          dispatch(setGuestsSplitiing(cabinPrices))
          dispatch(setRoomParams(roomParams))
          dispatch(setTotalPrice(totalPrice))
          setStep(3)
        }

        setCabins(cabins)
        dispatch(
          setSelectedTrip({
            ...selectedTrip[0],
            dateFrom: selectedTrip[0].startDate,
            dateTo: selectedTrip[0].endDate,
          })
        )
      })
      .finally(() => dispatch(showLoader(false)))
  }

  useEffect(() => {
    getRequirements()
  }, [selectedTrip?.itinerary?.id])

  useEffect(() => {
    if(tripId) {
      getTripData()
    }
  }, [tripId])

  return {
    requirements,
    selectedTrip,
    cabins,
  }
}
